export const application = 'bright-dev';

export const apiURL = '/bright/api';

export const academyURL = 'https://learnwithbright.academy';

export const vimeoURL = 'https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com';
